import { coreLog } from './logger.js';
const log = coreLog.getLogger('utilities', 'getBufferConfiguration');
function getConstructorFromType(bufferType, isVolumeBuffer) {
    switch (bufferType) {
        case 'Float32Array':
            return Float32Array;
        case 'Uint8Array':
            return Uint8Array;
        case 'Uint32Array':
            return Uint32Array;
        case 'Uint16Array':
        case 'Int16Array':
            if (!isVolumeBuffer) {
                return bufferType === 'Uint16Array' ? Uint16Array : Int16Array;
            }
            else {
                log.debug(`${bufferType} is not supported for volume rendering, switching back to Float32Array`);
                return Float32Array;
            }
        default:
            if (bufferType) {
                throw new Error('TargetBuffer should be Float32Array, Uint8Array, Uint16Array, Int16Array, or Uint32Array');
            }
            else {
                return Float32Array;
            }
    }
}
function getBufferConfiguration(targetBufferType, length, options = {}) {
    const { isVolumeBuffer = false } = options;
    const TypedArrayConstructor = getConstructorFromType(targetBufferType, isVolumeBuffer);
    const bytesPerElement = TypedArrayConstructor.BYTES_PER_ELEMENT;
    const numBytes = length * bytesPerElement;
    return { numBytes, TypedArrayConstructor };
}
function volumeTextureBytes(voxelCount, dataType, numberOfComponents = 1) {
    const values = voxelCount * Math.max(numberOfComponents || 1, 1);
    if (!dataType) {
        return values;
    }
    return getBufferConfiguration(dataType, values, { isVolumeBuffer: true })
        .numBytes;
}
export { getBufferConfiguration, getConstructorFromType, volumeTextureBytes };
